import React from 'react';
import { isEmpty } from 'lodash';
import { FieldChangeGrid } from '@pages/admin/audit-log/change-grid';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from '@pages/admin/audit-log/service';

const fieldsToHide: string[] = ['IsDeleted', 'ResponsibleFunction', 'CompletedDatePopulatedOn', 'Owner', 'OwnerId'];

const SubjectActionsAuditLogGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    if (isEmpty(oldRecord) && isEmpty(newRecord)) return null;

    const refactoredOldRecord = oldRecord
        ? {
              ...oldRecord,
              ...removePropertiesFromObject(oldRecord, fieldsToHide),
              OwnerName: oldRecord.OwnerName ? oldRecord.OwnerName : oldRecord.Owner?.Name,
          }
        : oldRecord;

    const refactoredNewRecord = newRecord
        ? {
              ...newRecord,
              ...removePropertiesFromObject(newRecord, fieldsToHide),
              OwnerName: newRecord.OwnerName ? newRecord.OwnerName : newRecord.Owner?.Name,
          }
        : newRecord;

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export default SubjectActionsAuditLogGrid;
